import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import ErrorPage from '@/pages/errorPage';
import AdminShellLayout from '@/components/layout/AdminShellLayout';

const RootLayout = () => <Outlet />;

const AdminConsole = lazy(() => import('@/pages/admin/AdminConsole'));
const AdminCustomers = lazy(() => import('@/pages/admin/AdminCustomers'));
const CustomerBillingDetails = lazy(() => import('@/pages/admin/CustomerBillingDetails'));
const EnterpriseLibraryAdmin = lazy(() => import('@/pages/enterpriseLibraryAdmin'));
const PipelineCompanies = lazy(() => import('@/pages/admin/pipeline/PipelineCompanies'));
const PipelineCompanyDetail = lazy(() => import('@/pages/admin/pipeline/PipelineCompanyDetail'));
const StaffSignIn = lazy(() => import('@/pages/admin/StaffSignIn'));
const StaffOAuthCallback = lazy(() => import('@/pages/admin/StaffOAuthCallback'));
const CustomProcessors = lazy(() => import('@/pages/admin/CustomProcessors'));
const ProcessorEditor = lazy(() => import('@/pages/admin/ProcessorEditor'));

export const adminPageChildren = [
  { path: 'admin', element: <AdminConsole /> },
  { path: 'admin/pipeline/companies', element: <PipelineCompanies /> },
  { path: 'admin/pipeline/companies/:id', element: <PipelineCompanyDetail /> },
  { path: 'admin/customers', element: <AdminCustomers /> },
  { path: 'admin/billing/customer/:customerId', element: <CustomerBillingDetails /> },
  { path: 'admin/enterprise-library', element: <EnterpriseLibraryAdmin /> },
  { path: 'admin/processors', element: <CustomProcessors /> },
  { path: 'admin/processors/new', element: <ProcessorEditor /> },
  { path: 'admin/processors/:id', element: <ProcessorEditor /> },
];

export const staffAuthPublicRoutes = [
  {
    path: '/admin/sign-in',
    element: <StaffSignIn />,
  },
  {
    path: '/admin/oauth/callback',
    element: <StaffOAuthCallback />,
  },
];

const staffHostTenantAuthAliases = [
  {
    path: '/sign-in',
    element: <Navigate to="/admin/sign-in" replace />,
  },
  {
    path: '/login',
    element: <Navigate to="/admin/sign-in" replace />,
  },
];

export const staffAdminRoutes = [
  {
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      ...staffAuthPublicRoutes,
      ...staffHostTenantAuthAliases,
      {
        element: <AdminShellLayout />,
        children: [
          { index: true, element: <Navigate to="/admin" replace /> },
          ...adminPageChildren,
        ],
      },
    ],
  },
];
